































































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';

@Component
export default class QueryHeaderForm extends Vue {
  @Prop() 
  model: any;
  
  @Prop() 
  emptyValue: any;

  @Emit('remove')
  onRemove(model: any) {}

  set selected(value: any) {
    const selected = value.map((item: any) => typeof item === 'string' ? item : item.value);
    this.$set(this.model, 'selected', selected);
  } 

  get selected() {
    return this.model.selected
      .map((item: any) => {
        return item === this.emptyValue.value 
          ? this.emptyValue 
          : {
            text: item,
            value: item
          }
      });
  }

  get hasEmpty(): boolean {
    return this.model.selected.some((item: any) => item === this.emptyValue.value);
  }

  set hasEmpty(value: boolean) {
    const selected = !value
      ? this.model.selected.filter((item: any) => item !== this.emptyValue.value)
      : this.hasEmpty
        ? this.model.selected
        : this.model.selected.concat([this.emptyValue.value]);

    this.$set(this.model, 'selected', selected);
    this.$set(this.model, 'include_empty', value);
  }
}
